import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { serverResponse } from "./valdators";

export async function getMsisdnNumbersForReservation() {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/MSISDN/v2`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
        version: "2",
      },
      validator: serverResponse,
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok({
    numbers: result.value,
  });
}
